import {
    getNeverbounceApiKey,
    getNeverbounceTimeout,
} from "@utils/configuration/aem";
import { useScript } from "@utils/hooks/useScript.hook";

type UseNeverbounceScriptProps = {
    disabled?: boolean;
};

const useNeverbounceScript = ({ disabled }: UseNeverbounceScriptProps) => {
    const status = useScript(
        "https://cdn.neverbounce.com/widget/dist/NeverBounce.js",
        "neverbounce",
        disabled,
        () => {
            if (!window._NBSettings) {
                window._NBSettings = {
                    apiKey: getNeverbounceApiKey(),
                    apiOnly: true,
                    timeout: Number(
                        (getNeverbounceTimeout() / 1000).toFixed(2),
                    ),
                };
            }
        },
    );

    return status;
};

export { useNeverbounceScript };
